export * from '@primeuix/themes/aura/toggleswitch';
export { default } from '@primeuix/themes/aura/toggleswitch';
